/* eslint-disable max-len */
import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { useGlobalProgress } from '../VehicleProfilingHub/progress.hooks';
import { PART_OF_GLOBAL_PROGRESS } from '../VehicleProfilingHub/VehicleProfilingHub.constants';
import LocalTexts from '../VehicleProfilingTexts.json';

import { ProgressLine } from './ProgressLine';
import { ProgressPip } from './ProgressPip';

import styles from './VehicleHubProgressBar.module.scss';

const LocalT = new MDText(LocalTexts);

export type VehicleHubProgressBarProps = {
  children?: React.ReactNode;
  className?: string | string[];
}

type PipPart = { elements: React.ReactNode[]; step: number };

export const VehicleHubProgressBar = ({
  children, className,
}: VehicleHubProgressBarProps) => {
  const globalProgress = useGlobalProgress();

  const progressPipParts = [
    PART_OF_GLOBAL_PROGRESS.BASIC,
    PART_OF_GLOBAL_PROGRESS.VEHICLE_DETAILS,
    PART_OF_GLOBAL_PROGRESS.PHOTOS,
  ];

  return (
    <div className={cx(styles.component, className)} data-testid="vehicleHubProgressBar">
      <div className={styles.progressBar}>
        <ProgressLine
          className={styles.progressLine}
          progress={globalProgress}
          sticky={false}
        />
        {progressPipParts.reduce<PipPart>((acc, pipPart) => {
          const step = acc.step + pipPart;
          return {
            elements: [
              ...acc.elements,
              <ProgressPip key={step} progress={globalProgress} step={step} />,
            ],
            step,
          };
        }, { elements: [], step: 0 }).elements}
      </div>

      <div className={styles.wrapper}>
        <p>
          {LocalT.translate('progressBar.complete', { progress: globalProgress })}
        </p>
        {children}
      </div>
    </div>
  );
};
